// extracted by mini-css-extract-plugin
export default {"content":"CustomerDashboard_content__vrV9G","tabs":"CustomerDashboard_tabs__lS1mG"};